import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';


@Pipe({
    name: 'momentFormat',
    standalone: true // Angular 19 default for pipes
})
export class MomentFormatPipe implements PipeTransform {
    transform(value: any, formatString: string = 'YYYY-MM-DD'): string {
        if (!value) {
            return '';
        }
        return moment(value).format(formatString);
    }
}